import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  animation: {
    animation: 'animation-shimmering 1.5s linear infinite',
    backgroundColor: theme.palette.grey[100],
    backgroundImage: `linear-gradient(-90deg, ${theme.palette.grey[100]} 0%, ${theme.palette.grey[200]} 50%, ${theme.palette.grey[100]} 100%)`,
    backgroundPosition: '-300px 0',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '300px 100%',
  },
  divider: {
    backgroundColor: theme.palette.grey[100],
  },
}));

export default styles;
